import * as React from "react";

function TestimonialsVideo() {
  return (
    <div className="grid grid-cols-12 w-full h-full relative py-14 bg-light-blue">
      <div className="col-span-12 text-center pb-12 px-8">
        <h2>"I feel for the first time in my life that we are 100% in control of our finances"</h2>
        <p>We manage over $2 billion of assets for over 20,000+ clients across the globe, helping them achieve their financial goals.</p>
      </div>
      <div className="col-span-12 lg:col-start-3 lg:col-end-11">
        <div className="grid grid-cols-12 gap-4 px-10">
          <div className="col-span-12 lg:col-span-4">
            <div className="wistia_responsive_padding" style={{ position: 'relative', overflow: 'hidden', paddingTop: '100%' }}>
            <iframe
                title="Testimonials Video 1"
                src="https://customer-iclu53owqhlji7yh.cloudflarestream.com/2f664473386da9c4571ef24b6be29ebd/iframe?preload=true&poster=https%3A%2F%2Fholbornassets.com%2Fwp-content%2Fuploads%2F2023%2F12%2FReto.jpg"
                allowtransparency="true"
                frameBorder="0"
                scrolling="no"
                style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', height: '100%', width: '100%' }}
                allowFullScreen={true}
                mozallowfullscreen="true"
                webkitallowfullscreen="true"
                oallowfullscreen="true"
                msallowfullscreen="true"
                ></iframe>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-4 hidden lg:block">
            <div className="wistia_responsive_padding" style={{ position: 'relative', overflow: 'hidden', paddingTop: '100%' }}>
            <iframe
                title="Testimonials Video 2"
                src="https://customer-iclu53owqhlji7yh.cloudflarestream.com/bd6e8a57cc24bca51e233cce13ee9740/iframe?preload=true&poster=https%3A%2F%2Fholbornassets.com%2Fwp-content%2Fuploads%2F2023%2F12%2FShruti.jpg"  allowtransparency="true"
                frameBorder="0"
                scrolling="no"
                style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', height: '100%', width: '100%' }}
                allowFullScreen={true}
                mozallowfullscreen="true"
                webkitallowfullscreen="true"
                oallowfullscreen="true"
                msallowfullscreen="true"
                ></iframe>

              
            </div>
          </div>
          <div className="col-span-12 lg:col-span-4 hidden lg:block">
            <div className="wistia_responsive_padding" style={{ position: 'relative', overflow: 'hidden', paddingTop: '100%' }}>
            <iframe
                title="Testimonials Video 3"
                src="https://customer-iclu53owqhlji7yh.cloudflarestream.com/497aa3522e6d6b818192af1f2b16baed/iframe?preload=true&poster=https%3A%2F%2Fholbornassets.com%2Fwp-content%2Fuploads%2F2023%2F12%2FPaul.jpg"  allowtransparency="true"
                frameBorder="0"
                scrolling="no"
                style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', height: '100%', width: '100%' }}
                allowFullScreen={true}
                mozallowfullscreen="true"
                webkitallowfullscreen="true"
                oallowfullscreen="true"
                msallowfullscreen="true"
                ></iframe>
             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TestimonialsVideo;
